module.exports = __webpack_public_path__ + "img/ic_publicity_detail1_3.837b208b.png";